import { strings } from '@securionpay-internal/commons-js';
import Frame from '../Frame';
import applyStyles from "../dom/applyStyles";
import { COMPANY_NAME } from '../../env';
import { ModalId } from './inner/ModalId';

export class ApmModalFrame<TParams extends { isTestMode: boolean, modalId: ModalId }> extends Frame {
    constructor(src: string, controllerId: string, params?: TParams) {
        super(src, controllerId, params);
    }

    _createIframe(params: any): HTMLIFrameElement {
        const iframe = super._createIframe(params);
        iframe.classList.add('apm-modal-frame');
        iframe.setAttribute('title', 'Payment method details');
        iframe.setAttribute('aria-label', 'Payment method details');
        applyStyles(iframe, {
            position: 'fixed',
            top: '0px',
            left: '0px',
            height: '100%',
            width: '100%',
            'z-index': '2147483647'
        });
        return iframe;
    }

    _generateId() {
        return strings.unique(`__private${COMPANY_NAME}ApmModalFrame`);
    }
}
